import UnderConstruction from "../../errors/under-construction";
const TimesheetTable = (): JSX.Element => {
  return <UnderConstruction />;
};

export default TimesheetTable;
